import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstOft: [],
        oft: {},
        ofu: {},
        lstOfu: [],
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getOft(state) {
            let oft = { ...state.oft }
            oft.lstOfu = state.lstOfu
            return oft
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        }
    },
    mutations: {
        set(state, oft) {
			state.oft = { ...oft }
            if (oft)
                state.update = true
		},
        initForm(state) {
            state.insert = false
            state.update = false
            state.oft = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOft = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOft(state, oft) {
            state.oft = oft
        },
        setLstOft(state, lstOft) {
            state.lstOft = lstOft
        },
        setLstOfu(state, lstOfu) {
            state.lstOfu = lstOfu
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, oftreprova) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/Failed/Find/${oftreprova}`)
                .then(response => {
                    let oft = Utils.ValidateAxiosResponse(response.data);
                    commit("set", oft)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, oftreprova) {
            return await this._vm.$axios.get(`/Oryxplace/Failed/Find/${oftreprova}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/OryxPlace/Failed/Insert", getters.getOft)
                .then(response => {
                    let oft = Utils.ValidateAxiosResponse(response.data);
                    commit('setLastUpdatedRegister', oft);
                    commit("set", oft)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Oryxplace/Failed/Update", getters.getOft)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Oryxplace/Failed/Delete/${getters.getOft.oftreprova}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    window.location.reload(true)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findByOrder({ commit, dispatch }, oftordem) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/Failed/FindByOrder/${oftordem}`)
                .then(response => {
                    let oft = Utils.ValidateAxiosResponse(response.data);
                    commit("set", oft)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async findProductList({ commit, dispatch }, oftreprova) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/Failed/FindProductList/${oftreprova}`, )
                .then(response => {
                    let lstOfu = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstOfu", lstOfu)
                }).catch(error => {
                    commit("setLstOfu", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async findManufacturerByProduct({ state, dispatch }, ofuidrecip) {
            return await this._vm.$axios.get(`/OryxPlace/Failed/findManufacturerByProduct/${ofuidrecip}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                state.ofu = { ofuidrecip: payload.ofuidrecip, ofunome: payload.ofunome, ofucodfab: payload.ofucodfab, ofufabr: payload.ofufabr, ofucapacit: payload.ofucapacit }
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: "Cilindro não encontrado"
				}, { root: true })
                state.ofu = {}
				return null 
            });
        },
    }
}